import { Outlet } from "react-router-dom";

import Header from "components/Header";
import TabSwitch from "components/TabSwitch";
import { CREDIT_TAB_ITEMS } from "constants/haulpay";
import { routes } from "constants/routes";
import MainLayout from "layouts/Main";

export default function Credit() {
  return (
    <MainLayout
      desktopTitle="Credit"
      customHeader={<Header label="Credit" goBackPath={routes.HAULPAY} isHideDesktop />}
      className="gap-5 px-5">
      <TabSwitch options={CREDIT_TAB_ITEMS} />

      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </MainLayout>
  );
}
